// src/services/sqlService.js
export async function checkSQLConnection() {
    try {
      const connString = process.env.REACT_APP_SQL_CONN;
      // console.log("Attempting SQL connection test with:", connString);
      const isReachable = connString.includes("mssql+") && connString.includes("@");
      return isReachable;
    } catch (err) {
      console.error("SQL connection test failed:", err);
      return false;
    }
  }
  